











































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "StatisticsOverview",
  components: {
    Loading,
    OnscreenMenu,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      UserPermissionRank: UserPermissionRank,
      birthdaysStatistics: null as { programTitle: string; count: string }[] | null,

      useFilters: false as boolean,
      cachedFilterDates: {
        beginDate: "",
        endDate: "",
      } as { [index: string]: string },
      filterDates: {
        beginDate: "",
        endDate: "",
      } as { [index: string]: string },
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    loadData() {
      this.loadStatistics();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadStatistics() {
      this.birthdaysStatistics = null;

      var filterBeginDate = null;
      var filterEndDate = null;

      //filters
      if (this.useFilters) {
        if (this.filterDates["beginDate"] != "") {
          filterBeginDate = new Date(this.filterDates["beginDate"]);
        }
        if (this.filterDates["endDate"] != "") {
          filterEndDate = new Date(this.filterDates["endDate"]);
        }
      }

      if (this.restClient != null) {
        try {
          this.birthdaysStatistics = await this.restClient.getBirthdayBookingStatistics(filterBeginDate, filterEndDate);

          this.sortBirthdaysStatisticsByCount();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    sortBirthdaysStatisticsByCount: function () {
      if (this.birthdaysStatistics != null) {
        this.birthdaysStatistics.sort(function (a, b) {
          let countA = a.count;
          let countB = b.count;
          if (countA > countB) {
            return -1;
          }
          if (countA < countB) {
            return 1;
          }
          return 0;
        });
      }
    },

    //START date handling

    setFilterDates() {
      var filterDate = "";

      let k = this.cachedFilterDates;
      let i: keyof typeof k;

      for (i in this.cachedFilterDates) {
        if (this.supportsDatePicker) {
          filterDate = this.cachedFilterDates[i];
        } else {
          if (this.cachedFilterDates[i].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedFilterDates[i]);

            if (d != null) {
              filterDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.filterDates[i] = filterDate;
      }
    },

    //END date handling

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadStatistics();
    },

    removeUseFilters() {
      this.useFilters = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadStatistics();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    birthdaysTotalCount(): number | undefined {
      if (this.birthdaysStatistics != null) {
        var totalCount: number = 0;

        for (let i = 0; i < this.birthdaysStatistics.length; i++) {
          totalCount += parseInt(this.birthdaysStatistics[i].count);
        }

        return totalCount;
      }
    },
  },
});
